module.exports = __webpack_public_path__ + "img/1.5b123ecc.jpg";